module.exports = __webpack_public_path__ + "static/IMG_0380-6e03245b6d6794c70e9e04f29a589643.jpg";